
import TeamsList from "./pages/TeamsList.vue";
import UsersList from "./pages/UsersList.vue";
import TeamMembers from "./components/teams/TeamMembers.vue";
import NotFound from "./pages/NotFound.vue";

//Auth 회원관리
import AuthLogin from "./pages/auth/Login.vue";
import AuthRegister from "./pages/auth/Register.vue";
import AuthPWReset from "./pages/auth/ResetPassword.vue";
import AuthFindID from "./pages/auth/FindID.vue";

import TeamsFooter from "./components/teams/TeamsFooter.vue";
import UsersFooter from "./components/users/UsersFooter.vue";
import UserAuth from '@/pages/auth/UserAuth.vue';
import CoachDetail from '@/pages/coaches/CoachDetail.vue';
import CoachesList from '@/pages/coaches/CoachesList.vue';
import CoachRegistation from '@/pages/coaches/CoachRegistration.vue';
import ContactCoach from '@/components/requests/ContactCoach.vue';
import RequestsReceived from '@/pages/coaches/RequestsReceived.vue';
import Main from '@/layout/Main.vue';
import Home from '@/pages/Home.vue';
import Sub from '@/layout/Sub.vue';


//채팅
import ChatRoom from '@/pages/chat/ChatRoom.vue'
import ChatroomCreate from '@/pages/chat/ChatroomCreate.vue'
import ChatMain from '@/pages/chat/ChatMain.vue'
import ChatLobby from '@/pages/chat/ChatLobby.vue'
import ChatDefault from '@/pages/chat/ChatDefault.vue'
import ChatMtm from '@/pages/chat/ChatMtm.vue'

//게시판
import Post from '@/pages/posts/Post.vue'
import PostList from '@/pages/posts/PostList.vue'
import PostView from '@/pages/posts/PostView.vue'
import PostWrite from '@/pages/posts/PostRegistration.vue'
import Attendance from '@/pages/posts/Attendance.vue'

//게시판 검색
import PostSearch from '@/pages/posts/PostSearch.vue'

//게등위검색
import GracSearch from '@/pages/posts/GracSearch.vue'

//약관
import PolicyService from '@/components/policy/Service.vue'
import PolicyPrivacy from '@/components/policy/Privacy.vue'
import PolicyRefusal from '@/components/policy/Refusal.vue'
import PolicyYouth from '@/components/policy/Youthpolicy.vue'
import PolicyManager from '@/components/policy/ManagerPolicy.vue'

//마이페이지
import MyPage from '@/pages/mypages/MyPage.vue'
import MyProfile from '@/pages/mypages/MyProfile.vue'
import MyPost from '@/pages/mypages/MyPost.vue'
import MyPoint from '@/pages/mypages/MyPoint.vue'
import MyFriend from '@/pages/mypages/MyFriend.vue'
import MyItem from '@/pages/mypages/MyItem.vue'
import MyItemBuy from '@/pages/mypages/MyItemBuy.vue'//구매내역, 보유내역 유효아이템
import MyItemUse from '@/pages/mypages/MyItemUse.vue'//사용내역
import MyItemValidity from '@/pages/mypages/MyItemValidity.vue'//유효아이템
import MyChild from '@/pages/mypages/MyChild.vue'//추천인 포인트 내역 & 추천인 목록
import MyChildReward from '@/pages/mypages/MyChildReward.vue'
import MyChildList from '@/pages/mypages/MyChildList.vue'
import SelfAuth from '@/pages/mypages/SelfAuth.vue'//본인인증페이지
import MyGoods from '@/pages/mypages/MyGoods.vue'
import MyGoodsBuy from '@/pages/mypages/MyGoodsBuy.vue'//구매내역, 보유내역 유효아이템
import LeveService from '@/pages/mypages/LeaveService.vue'//탈퇴

//쪽지
import Message from '@/pages/message/Message.vue'
import MessageSend from '@/pages/message/Send.vue'
import MessageReceive from '@/pages/message/Receive.vue'
import MessageWrite from '@/pages/message/Write.vue'
import MessageFriend from '@/pages/message/FriendsList.vue'

//아이템
import Item from '@/pages/item/Item.vue'
import ItemList from '@/pages/item/ItemList.vue'
import ItemView from '@/pages/item/ItemView.vue'
import Dev from '@/components/ui/dev.vue'

//결제
import PaymentResult from '@/pages/payment/Result.vue'

//P샵 상품
import Goods from '@/pages/goods/Goods.vue'
import GoodsList from '@/pages/goods/GoodsList.vue'
import GoodsView from '@/pages/goods/GoodsView.vue'


//위젯
import WidgetMain from '@/widgets/Main.vue'
import WidgetCounter from '@/widgets/Counter.vue'

export default[
        { path: '/', redirect: { name: 'home' } },
        { path: '/mypage', redirect: { name: 'myProfile' } },
        {
            path:'/',
            name:'main',
            component:Main,
            children: [
                {name:'home', path:'home', component:Home},
                { name:'myPage', path:'mypage', component: MyPage,meta: { requiresAuth: true },
                    children:[
                        { name:'myProfile', path:'profile', component: MyProfile, props:true},
                        { name:'myPost', path:'post', component: MyPost, props:true},
                        { name:'myPoint', path:'point', component: MyPoint, props:true},
                        { name:'myFriend', path:'friend', component: MyFriend, props:true},
                        { name:'myItem', path:'item', component: MyItem,redirect: { name: 'MyItemBuy' },
                            children:[
                                { name:'MyItemBuy', path:'buy', component: MyItemBuy, props:true},
                                { name:'MyItemUse', path:'use', component: MyItemUse, props:true},
                                { name:'MyItemValidity', path:'validity', component: MyItemValidity, props:true},
                            ]
                        },
                        { name:'myGoods', path:'goods', component: MyGoods,redirect: { name: 'MyGoodsBuy' },
                            children:[
                                { name:'MyGoodsBuy', path:'buy', component: MyGoodsBuy, props:true},                               
                            ]
                        },
                        //본인인증
                        { name:'selfAuth', path:'selfauth', component: SelfAuth,props:true},
                        
                        { name:'message', path:'message', component: Message,props:true},
                        
                        //자기 하부를 통해 받은 적립금 내역                        
                        { name:'myChild', path:'mychild', component: MyChild,redirect: { name: 'myChildReward' },
                            children:[
                                { name:'myChildReward', path:'childreward', component: MyChildReward, props:true},
                                { name:'myChildList', path:'childlist', component: MyChildList, props:true},                               
                            ]
                        },

                        //탈퇴
                        { name:'leave_service', path:'leave_service', component: LeveService, props:true},
                    ]
                },
                { name:'register',path: 'main/register', component: CoachRegistation ,meta: { requiresAuth: true } },
                { path: 'main/requests', component: RequestsReceived ,meta: { requiresAuth: true } },
                { name:'community', path:'main/community', component:Post, props: true,
                    children:[
                        { name:'community_list', path:':menu/:document', component: PostList, props:true,
                            children:[
                                {name:'postview', path:'view/:id', component: PostView, props:true},
                            ]
                        },
                        {name:'attendance', path:'attendance', component: Attendance, props:true },
                        {name:'postwrite', path:':document/write', component: PostWrite, props:true ,meta: { requiresAuth: true }},
                        {name:'postedit', path:'edit', component: PostWrite, props:true ,meta: { requiresAuth: true }},
                        {name:'gracsearch', path:'gracsearch', component: GracSearch, props:true },
                        {name:'postsearch', path:'postsearch', component: PostSearch, props:true },
                        {name:'postsearch_view', path:'postsearch/view/:id', component: PostSearch, props:true },
                    ]
                },
                //약관
                { name:'service', path:'main/policy/service', component:PolicyService},
                { name:'privacy', path:'main/policy/privacy', component:PolicyPrivacy},
                { name:'refusal', path:'main/policy/refusal', component:PolicyRefusal},
                { name:'youth', path:'main/policy/youth', component:PolicyYouth},
                { name:'managerpolicy', path:'main/policy/manager', component:PolicyManager},
                
                //아이템
                { name:'item', path:'main/item', component:Item,redirect: { name: 'itemlist' },
                    children:[
                        {name:'itemlist', path:'list', component: ItemList, props:true },
                        {name:'itemview', path:'view/:id', component: ItemView, props:true },
                        {name:'itemview_dev', path:'view_dev/:id', component: ItemView, props:true },
                    ]
                },

                //P샵 상품
                { name:'goods', path:'main/goods', component:Goods,redirect: { name: 'goodslist' },
                    children:[
                        {name:'goodslist', path:'list', component: GoodsList, props:true },
                        {name:'goodsview', path:'view/:id', component: GoodsView, props:true },
                    ]
                },
            ]
        },
        {
            path:'/main',
            name:'mainSub',
            component:Sub,
            children: [
                { name:'coaches', path: 'coaches', component: CoachesList },
                {
                  path: 'coaches/:id',
                  component: CoachDetail,
                  props: true,
                  children: [
                    { path: 'contact', component: ContactCoach } // /coaches/c1/contact
                  ]
                },
                // { name:'register',path: 'register', component: CoachRegistation ,meta: { requiresAuth: true } },
                // { path: 'requests', component: RequestsReceived ,meta: { requiresAuth: true } },
                // { name:'community', path:'community', component:Post, props: true,
                //     children:[
                //         { name:'community', path:':menu/:document', component: PostList, props:true,
                //             children:[
                //                 {name:'postview', path:'view/:id', component: PostView, props:true},
                //             ]
                //         },
                //         {name:'attendance', path:'attendance', component: Attendance, props:true },
                //         { path:':document/write', component: PostWrite, props:true ,meta: { requiresAuth: true }},
                //         {name:'postedit', path:'edit', component: PostWrite, props:true ,meta: { requiresAuth: true }},
                //     ]
                // },
                // //약관
                // { name:'service', path:'policy/service', component:PolicyService},
                // { name:'privacy', path:'policy/privacy', component:PolicyPrivacy},
                // { name:'refusal', path:'policy/refusal', component:PolicyRefusal},
                // { name:'youth', path:'policy/youth', component:PolicyYouth}
            ]
        },
        //채팅
        { name:'chat_main', path: '/chat', component: ChatMain,
            children:[
                { name:'chat_Lobby' , path:'lobby', component:ChatLobby },
                { name:'chat_Default' , path:'default', component:ChatDefault },
                { name:'chat_room' , props: true, path:'room/:room_id', component:ChatRoom },
                { name:'chat_roomCreate', path:'create', component:ChatroomCreate },
                {path:'dev', component:Dev},
                { name:'chat_mtm', props:true, path:'mtm/:mtm_id', component:ChatMtm}
            ]
        },
        //쪽지 팝업
        { name:'pop_message', path:'/pop/message', redirect: { name: 'message_receive' },
            component: Message, props:true,meta: { requiresAuth: true },
            children:[
                { name:'message_send', path:'/pop/message/send', component: MessageSend, props:true,},
                { name:'message_receive', path:'/pop/message/receive', component: MessageReceive, props:true,},
                { name:'message_write_nor', path:'/pop/message/Write', component: MessageWrite, props:true,},
                { name:'message_write', path:'/pop/message/Write/:userNic', component: MessageWrite, props:true,},
                { name:'message_friends_list', path:'/pop/message/friends', component: MessageFriend, props:true,},
            ]
        },

        //게시판 관련
        // { name:'post', path: '/post', component: Post,
        //   children:[
        //     { name:'postlist' , path:'list', component:PostList },
        //     { name:'postregistration' , path:'register', component:PostRegistration },
        //     { name:'postview' , path:'view/:post_id', component:PostView , props: true},
        //   ]
        // },

        //유저 인증 관련
        { name: 'auth', path: '/auth', component: UserAuth ,meta: { requiresAuth: true } },
        { name: 'auth_login', path: '/auth/login', component: AuthLogin ,meta: { requiresUnauth: true }, props: true, },
        { name: 'auth_register', path: '/auth/register', component: AuthRegister ,meta: { requiresUnauth: true } },        
        { name: 'auth_pwreset', path: '/auth/reset_pw', component: AuthPWReset ,meta: { requiresUnauth: true } },
        { name: 'auth_findid', path: '/auth/findid', component: AuthFindID ,meta: { requiresUnauth: true } },
        {
            name: 'teamsa',
            path: "/teams",
            meta: { needsAuth: true },
            components: { default: TeamsList, footer: TeamsFooter },
            children: [
                { name: 'team-members', path: ":teamId", component: TeamMembers, props: true }, //teams/t1 식으로
            ],
        }, //our-domain.com/teams => ...

        { name: 'payment_result', path: '/payment/result', component: PaymentResult },

        {
            path: "/users", components: { default: UsersList, footer: UsersFooter },
            beforeEnter(to, from, next) {
                console.log('users beforeEnter')
                console.log(to, from)
                next()
            }
        },

        //위젯 쪽지, 접속자 리스트, 채팅기능등 관리자에 붙이기 위한... 
        { name: 'widget', path: '/widget', component:WidgetMain ,
            children: [
                { name:'widget_counter', path:'counter', component:WidgetCounter,props: true},   
                             
            ]
        },
        { path: "/:notFound(.*)", component: NotFound },
    ]


